/**
 * Profile feed tab keys
 */
export const PROFILE_FEED_TAB_KEYS = {
  POSTS: 'profile_posts',
  REPLIES: 'profile_replies',
};
